// src/mobile_pages/quality/components/MobileQualityNCView.jsx
// 모바일 전용 품질 NCR(부적합보고서) 뷰

import React from "react";
import { Calendar, MapPin, Building2, AlertTriangle, User, FileWarning } from "lucide-react";
import PeopleView from "../../../components/common/people/PeopleView";

export default function MobileQualityNCView({ data }) {
    if (!data) return null;

    const header = data.header || {};
    const ncr = data.ncr || {};

    return (
        <div className="space-y-4">

            {/* 기본 정보 카드 */}
            <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
                <div className="px-4 py-3 bg-red-50 border-b border-red-200">
                    <div className="flex items-center gap-2">
                        <FileWarning size={16} className="text-red-500" />
                        <h3 className="text-sm font-semibold text-red-700">부적합 보고서</h3>
                    </div>
                </div>
                <div className="p-4 space-y-3">
                    {/* 발생일 */}
                    <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-lg bg-amber-50 flex items-center justify-center flex-shrink-0">
                            <Calendar size={16} className="text-amber-500" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-xs text-slate-400 mb-0.5">발생일</p>
                            <p className="text-sm text-slate-900 font-medium">
                                {header.doc_date || "-"}
                            </p>
                        </div>
                    </div>

                    {/* 발생장소 */}
                    <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                            <MapPin size={16} className="text-blue-500" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-xs text-slate-400 mb-0.5">발생장소</p>
                            <p className="text-sm text-slate-900 font-medium break-words">
                                {header.location || "-"}
                            </p>
                        </div>
                    </div>

                    {/* 업체 */}
                    <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-lg bg-purple-50 flex items-center justify-center flex-shrink-0">
                            <Building2 size={16} className="text-purple-500" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-xs text-slate-400 mb-0.5">업체</p>
                            <p className="text-sm text-slate-900 font-medium">
                                {header.vendor || "-"}
                            </p>
                        </div>
                    </div>

                    {/* 부적합 유형 */}
                    <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center flex-shrink-0">
                            <AlertTriangle size={16} className="text-red-500" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="text-xs text-slate-400 mb-0.5">부적합 유형</p>
                            <p className="text-sm text-slate-900 font-medium">
                                {header.nc_type || "-"}
                            </p>
                        </div>
                    </div>

                    {/* 최종판정 / 제안자 */}
                    <div className="grid grid-cols-2 gap-3 pt-2 border-t border-slate-100">
                        <div>
                            <p className="text-xs text-slate-400 mb-0.5">최종판정</p>
                            <p className="text-sm text-slate-700 font-medium">{header.result || "-"}</p>
                        </div>
                        <div>
                            <p className="text-xs text-slate-400 mb-0.5">제안자</p>
                            <p className="text-sm text-slate-700">{ncr.proposer || "-"}</p>
                        </div>
                    </div>

                    {/* 조치 담당자 */}
                    <div className="pt-2 border-t border-slate-100">
                        <p className="text-xs text-slate-400 mb-2">조치 담당자</p>
                        <PeopleView
                            dns={data.doc_dns}
                            placeholder="지정된 담당자 없음"
                        />
                    </div>
                </div>
            </div>

            {/* 상세 내용 */}
            <div className="rounded-2xl bg-white border border-slate-200 overflow-hidden">
                <div className="px-4 py-3 bg-slate-50 border-b border-slate-200">
                    <h3 className="text-sm font-semibold text-slate-700">상세 내용</h3>
                </div>
                <div className="p-4 space-y-4">
                    {/* 부적합 내용 */}
                    <div>
                        <p className="text-xs font-medium text-slate-500 mb-2">부적합 내용</p>
                        <div className="rounded-xl bg-slate-50 p-3 text-sm text-slate-700 break-words">
                            {ncr.description || "내용이 없습니다."}
                        </div>
                    </div>

                    {/* 즉시/임시조치 */}
                    <div>
                        <p className="text-xs font-medium text-slate-500 mb-2">즉시/임시조치</p>
                        <div className="rounded-xl bg-slate-50 p-3 text-sm text-slate-700 break-words">
                            {ncr.immediate_action || "내용이 없습니다."}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
